import { getSharedProperty } from '@gn-audio/jss-core';

import { useFallbackTranslation } from '../../utils/hooks';
import { JabraFocusGroup, JabraFocusItem } from '../JabraFocus';
import { LanguageItem } from './LanguageItem';
import { LanguageSelectorVersionedProps } from './LanguageSelector.model';
import { DesktopRegionItem } from './RegionItem';

export const LanguageSelectorDesktop = ({
  regions,
  selectedRegion,
  focusedRegion,
  handleRegionSelect,
  currentLanguage,
}: LanguageSelectorVersionedProps) => {
  const { t } = useFallbackTranslation();

  return (
    <div className="max-lg:hidden lg:block">
      <JabraFocusGroup className="lg:flex" id="language">
        <JabraFocusGroup orientation="vertical" id="language-side">
          <ul
            className="site-selector flex w-auto flex-col"
            role="tablist"
            aria-label={t('topmenu.LanguageSelector')}
          >
            {regions.map((region) => (
              <DesktopRegionItem
                key={`desktop-ls-${region.id}`}
                id={`language-selector-tab-${region.id}`}
                region={getSharedProperty(region, 'title')?.value || ''}
                onSelect={() => handleRegionSelect(region.id)}
                active={selectedRegion === region.id}
                focused={focusedRegion === region.id}
                ariaControls={`language-selector-panel-${region.id}`}
              />
            ))}
          </ul>
        </JabraFocusGroup>
        <JabraFocusGroup id="language-items">
          {regions.map((region) =>
            selectedRegion === region.id ? (
              <ul
                key={`desktop-panel-ls-${region.id}`}
                className="my-3 ml-8 grid w-full grid-cols-4 gap-6 xl:grid-cols-5"
                role="tabpanel"
                id={`language-selector-tab-${region.id}`}
                aria-labelledby={`language-selector-tab-${region.id}`}
              >
                {region.languages.results.map((language) => {
                  const isActive = currentLanguage?.id === language.id;
                  return (
                    <JabraFocusItem key={`desktop-language-ls-${language.id}`}>
                      <LanguageItem
                        isActive={isActive}
                        icon={language.icon.jsonValue}
                        externalHost={language.targetHost.value}
                        locale={language.targetLocale.value}
                        language={language.languageName.value}
                        country={language.countryName.value}
                        focused={false}
                      />
                    </JabraFocusItem>
                  );
                })}
              </ul>
            ) : null
          )}
        </JabraFocusGroup>
      </JabraFocusGroup>
    </div>
  );
};
